import {
  Form,
  FormAutocomplete,
  FormCheckbox,
  FormPanel,
  FormTextField,
} from '@eas/common-web';

import { noop } from 'lodash';
import React from 'react';
import { AddressField } from '../../../components/form/address-field/address-field';
import { LocationPanel } from '../../../components/form/location-panel/location-panel';

import {
  useMinimalDistancesCategoryAutocomplete,
  useMinimalDistancesDeterminationMethodAutocomplete,
} from '../../minimal-distances/minimal-distances-api';
import { ProcessForm } from '../minimal-distances-new-types';
import { HelpLabel } from '../../../components/help/help-label';
import { dictionaryLabelMapper } from '../../../components/form/mappers/label-mappers';

export function StepSummaryContent({ allValues }: { allValues: ProcessForm }) {
  const categoryAutocomplete = useMinimalDistancesCategoryAutocomplete();
  const determinationAutocomplete = useMinimalDistancesDeterminationMethodAutocomplete();

  return (
    <Form editing={false} onSubmit={noop} initialValues={allValues}>
      <FormPanel
        label="Informace o provozovně, na které je zdroj veden"
        expandable={false}
        defaultExpanded={true}
      >
        <FormTextField
          name="ovzFacility.name"
          label={
            <HelpLabel
              label="Provozovna OVZ"
              code="MINIMAL_DISTANCES_OVZ_FACILITY"
              required
            />
          }
          disabled
        />
        <FormTextField
          name="ovzFacility.operator.name"
          label={
            <HelpLabel
              label="Provozovatel OVZ"
              code="MINIMAL_DISTANCES_NEW_OPERATOR"
              required
            />
          }
          disabled
        />
      </FormPanel>
      <FormPanel
        label="Specifikace zdroje"
        expandable={false}
        defaultExpanded={true}
      >
        <FormTextField
          name="sourceId"
          label={
            <HelpLabel
              label="Číslo zdroje"
              code="MINIMAL_DISTANCES_NEW_SOURCE_ID"
              required
            />
          }
        />
        <FormTextField
          name="name"
          label={
            <HelpLabel
              label="Název zdroje"
              code="MINIMAL_DISTANCES_NEW_SOURCE_NAME"
              required
            />
          }
        />
        <FormAutocomplete
          name="sourceCategory"
          source={categoryAutocomplete}
          labelMapper={(item) => `${item.code} ${item.name}`}
          label={
            <HelpLabel
              label="Zařazení zdroje podle přílohy č. 2a zákona"
              code="MINIMAL_DISTANCES_NEW_SOURCE_CATEGORY"
              required
            />
          }
        />
        <FormAutocomplete
          name="determinationMethod"
          source={determinationAutocomplete}
          labelMapper={dictionaryLabelMapper}
          label={
            <HelpLabel
              label="Způsob určení minimální vzdálenosti podle § 27d"
              code="MINIMAL_DISTANCES_NEW_DETERMINATION_METHOD"
              required
            />
          }
        />
        <FormCheckbox
          name="exemptFromMinDistances"
          label={
            <HelpLabel
              label="Výjimka z MV"
              code="MINIMAL_DISTANCES_NEW_EXEMPT_FROM_MIN_DISTANCES"
            />
          }
        />
      </FormPanel>

      <FormPanel
        label="Adresa zdroje - provozovna OVZ"
        expandable={false}
        defaultExpanded={true}
      >
        <AddressField name="ovzFacility.address" disabled={true} />
      </FormPanel>

      <LocationPanel
        locationName="wgs84Coordinates"
        locationValue={allValues.wgs84Coordinates}
        addressPanelLabel="Souřadnice zdroje"
        locationPanelLabel="Poloha zdroje"
        showCoordinates={true}
        showMap={true}
        showAddress={false}
        showLocationPanel={true}
        showCoordinatesDistance={false}
        locationToolbarProps={{
          showFillAddressBtn: false,
          showFillMapBtn: false,
        }}
        expandable={true}
        defaultExpanded={true}
      />
    </Form>
  );
}
